import { useStage } from './useStage'

export default () => useStage('random-code')
